import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const SleeperTrainPictogram = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M8.54004 0C10.0914 0 11.3486 1.2575 11.3486 2.80859V10.9883C11.3486 12.1641 10.4931 13.1435 9.37207 13.3389L11.1328 16H9.56738L8.84473 14.9072H2.50488L1.78223 16H0.21582L1.97754 13.3389C0.856101 13.1438 0 12.1642 0 10.9883V2.80859C0 1.2575 1.25781 0 2.80859 0H8.54004ZM3.51855 13.375L2.97461 14.1973H8.37402L7.83008 13.375H3.51855ZM2.38672 10.1982C1.97565 10.1984 1.64258 10.532 1.64258 10.9434C1.6426 11.3542 1.97566 11.6874 2.38672 11.6875C2.79792 11.6875 3.13181 11.3543 3.13184 10.9434C3.13184 10.5319 2.79794 10.1982 2.38672 10.1982ZM8.96191 10.1982C8.55073 10.1982 8.2168 10.5319 8.2168 10.9434C8.21682 11.3543 8.55074 11.6875 8.96191 11.6875C9.37304 11.6874 9.70603 11.3542 9.70605 10.9434C9.70605 10.5319 9.37306 10.1983 8.96191 10.1982ZM4.58008 2.2959C3.54633 2.7569 2.82422 3.79207 2.82422 4.99707C2.82439 6.63002 4.14832 7.95385 5.78125 7.9541C7.045 7.9541 8.12117 7.15992 8.54492 6.04492C8.20045 6.21566 7.82177 6.31053 7.4248 6.31055C5.82782 6.31055 4.53323 4.78103 4.5332 2.89355C4.5332 2.6893 4.55108 2.4904 4.58008 2.2959Z" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="solid" viewBox="0 0 11.3486 16">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { SleeperTrainPictogram };